$(window).load(function() {
  $('.flexsliderino').flexslider({
    animation: "slide"
  });
    $('.thumbnail-slider').flexslider({
    animation: "slide",
     animationLoop: true,
      touch: true, 
      itemWidth: 210,
    itemMargin: 5,
    minItems: 3,
    maxItems: 4
  });
  
  
});